import React, { useState, useEffect } from "react";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CmtCardFooter from "@coremat/CmtCard/CmtCardFooter";
import { Add } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import CmtCard from "@coremat/CmtCard";
import GridContainer from "@jumbo/components/GridContainer";
import NewsRequests from "services/news";

import moment from "moment-jalaali";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    marginTop: 10,
  },
  titleInput: {
    width: "100%",
  },
  formControl: {
    width: "100%",
  },
  title: {
    color: theme.palette.primary.main,
    marginBlock: "16px",
    fontWeight: "bold",
  },
  previewContainer: {
    width: "100%",
    display: "flex",
    marginTop: "16px",
    justifyContent: "center",
    "& img": {
      width: "190px",
      marginInline: "auto",
      borderRadius: "1rem",
    },
  },
  removeButton: {
    cursor: "pointer",
  },
  noLeftBorder: {
    borderRight: "none",
    borderRadius: "4px 0px 0px 4px",
  },
  inputContainer: {
    width: "100%",
    display: "flex",
  },
  leftButton: {
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
  },
}));

const Notificatoin = ({ notification }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { message } = useSelector(({ common }) => common);

  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");

  const [openAddDialog, setOpenAddDialog] = useState(false);

  const resetState = () => {
    setName("");
    setDesc("");
  };

  useEffect(() => {
    if (message === "با موفقیت اضافه شد") {
      dispatch(NewsRequests.getAllNotifications(1));
      resetState();
    }
  }, [message]);

  const handleAddAndClose = () => {
    const notificationData = {
      title: name,
      description: desc,
    };
    dispatch(NewsRequests.addNotificatoin(notificationData));
    setOpenAddDialog(false);
  };

  return (
    <React.Fragment>
      <div className={classes.cardContainer}>
        <CmtCard>
          <CmtCardContent>
            <GridContainer>
              {notification ? (
                <Grid item xs={12}>
                  <Typography variant="h3">{notification.title}</Typography>
                  <p
                    style={{ marginTop: "15px" }}
                    dangerouslySetInnerHTML={{
                      __html: notification.description,
                    }}
                  ></p>
                </Grid>
              ) : (
                <>
                  <Grid item xs={12}>
                    <TextField
                      id="prizeTitle"
                      label="عنوان اعلان"
                      variant="outlined"
                      className={classes.titleInput}
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className={classes.title}>توضیحات</Typography>
                    <TextField
                      id="prizeTitle"
                      label="عنوان اعلان"
                      variant="outlined"
                      className={classes.titleInput}
                      value={desc}
                      onChange={(e) => setDesc(e.target.value)}
                    />
                  </Grid>
                </>
              )}
            </GridContainer>
          </CmtCardContent>

          <CmtCardFooter
            separator={{
              color: "#bdbdbd",
              borderWidth: 1,
              borderStyle: "solid",
            }}
          >
            <Box>
              {notification ? (
                <Typography>
                  {moment(notification.createdAt).format("jYYYY/jMM/jDD")}
                </Typography>
              ) : (
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<Add />}
                  onClick={() => setOpenAddDialog(true)}
                  style={{ marginRight: 14 }}
                >
                  ایجاد اعلان جدید
                </Button>
              )}
            </Box>
          </CmtCardFooter>
        </CmtCard>
      </div>

      <Dialog
        open={openAddDialog}
        onClose={() => setOpenAddDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از اضافه کردن این اعلان اطمینان دارید ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddAndClose} color="primary">
            تایید
          </Button>
          <Button
            onClick={() => setOpenAddDialog(false)}
            color="secondary"
            autoFocus
          >
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default Notificatoin;
